import { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { ArrowRightCircle } from "react-bootstrap-icons";
import headerImage from "../assets/img/header-img.svg";
import TrackVisibility from "react-on-screen";
import "animate.css";

export const Banner = () => {
	const [loopNum, setLoopNum] = useState(0);
	const [isDeleting, setIsDeleting] = useState(false);
	const [text, setText] = useState("");
	const [delta, setDelta] = useState(300 - Math.random() * 100);
	const [_, setIndex] = useState(1);
	const toRotate = ["Software Developer", "Engineer"];
	const period = 2000;

	useEffect(() => {
		let ticker = setInterval(() => {
			tick();
		}, delta);

		return () => {
			clearInterval(ticker);
		};
	}, [text]);

	const tick = () => {
		let i = loopNum % toRotate.length;
		let fullText = toRotate[i];
		let updatedText = isDeleting
			? fullText.substring(0, text.length - 1)
			: fullText.substring(0, text.length + 1);

		setText(updatedText);

		if (isDeleting) {
			setDelta((prevDelta) => prevDelta / 2);
		}

		if (!isDeleting && updatedText === fullText) {
			setIsDeleting(true);
			setIndex((prevIndex) => prevIndex - 1);
			setDelta(period);
		} else if (isDeleting && updatedText === "") {
			setIsDeleting(false);
			setLoopNum(loopNum + 1);
			setIndex(1);
			setDelta(500);
		} else {
			setIndex((prevIndex) => prevIndex + 1);
		}
	};

	return (
		<section className="banner" id="home">
			<Container>
				<Row className="align-items-center">
					<Col xs={12} md={6} xl={7}>
						<TrackVisibility>
							{({ isVisible }) => (
								<div
									className={
										isVisible
											? "animate__animated animate__fadeIn"
											: ""
									}>
									<span className="tagline">
										Welcome to My Space
									</span>
									<h1>
										{"Hi I'm Eshan, "}
										<span
											className="txt-rotate"
											dataPeriod="1000"
											data-rotate='[ "Engineer", "Software Developer"]'>
											<span className="wrap">{text}</span>
										</span>
									</h1>
									<p>
										{" "}
										I want to learn and gain
										experience along the way.
									</p>
									<button
										onClick={() => console.log("Connect")}>
										<a
											className="con-anc"
											href="https://github.com/Eshanatnight">
											Check out my Github
										</a>
										<ArrowRightCircle size={25} />
										<br />
										<a
											className="pic-anc"
											href="https://dusk-neon.vercel.app">
											Check this out too!
										</a>
										<ArrowRightCircle size={25} />
									</button>
								</div>
							)}
						</TrackVisibility>
					</Col>
					<Col xs={12} md={6} xl={5}>
						<TrackVisibility>
							{({ isVisible }) => (
								<div
									className={
										isVisible
											? "animate__animated animate__zoomIn"
											: ""
									}>
									<img src={headerImage} alt="Header Img" />
								</div>
							)}
						</TrackVisibility>
					</Col>
				</Row>
			</Container>
		</section>
	);
};
